import { render } from "./CancelBets.vue?vue&type=template&id=32de32c0"
import script from "./CancelBets.vue?vue&type=script&lang=js"
export * from "./CancelBets.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__